import { LoaderCircle, RefreshCw, Wifi, WifiOff, type LucideIcon } from 'lucide-react';
import { Tooltip } from '../components/ui/Tooltip.tsx';
import { cx } from '../lib/cx.ts';
import { useRealtimeState, type RealtimeConnectionState } from '../lib/realtime.ts';

const STATES: Record<RealtimeConnectionState, { icon: LucideIcon; label: string; short: string; tone: string; spin?: boolean }> = {
  idle: { icon: WifiOff, label: 'ยังไม่ได้เชื่อมต่อข้อมูลสด', short: 'ไม่เชื่อมต่อ', tone: 'neutral' },
  connecting: { icon: LoaderCircle, label: 'กำลังเชื่อมต่อข้อมูลสด…', short: 'กำลังเชื่อมต่อ', tone: 'warning', spin: true },
  open: { icon: Wifi, label: 'เชื่อมต่อแล้ว ข้อมูลอัปเดตอัตโนมัติ', short: 'ออนไลน์', tone: 'success' },
  reconnecting: { icon: RefreshCw, label: 'การเชื่อมต่อขาดหาย กำลังเชื่อมต่อใหม่…', short: 'กำลังเชื่อมต่อใหม่', tone: 'warning', spin: true },
  offline: { icon: WifiOff, label: 'ออฟไลน์ ข้อมูลที่เห็นอาจไม่เป็นปัจจุบัน', short: 'ออฟไลน์', tone: 'danger' },
};

/** Topbar live-data status: icon + Thai tooltip, announced politely to screen readers. */
export function RealtimeIndicator() {
  const state = useRealtimeState();
  const ui = STATES[state];
  const Icon = ui.icon;
  return (
    <Tooltip content={ui.label} side="bottom" describeChild={false}>
      <span className={cx('live-indicator', `live-indicator--${ui.tone}`)} role="status" tabIndex={0} aria-label={ui.label}>
        <Icon className={ui.spin ? 'spin' : undefined} size={18} strokeWidth={1.75} aria-hidden="true" />
        <span className="live-indicator__text" aria-hidden="true">
          {ui.short}
        </span>
      </span>
    </Tooltip>
  );
}
